import { render } from "./updatepayment.vue?vue&type=template&id=56f31ec4"
import script from "./updatepayment.vue?vue&type=script&lang=js"
export * from "./updatepayment.vue?vue&type=script&lang=js"

import "./updatepayment.vue?vue&type=style&index=0&id=56f31ec4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__